(function($) {
  
  $(document).ready(function() {
    
  });
  
})(jQuery);

function initHeaderMenuOpener(){
  var $ = jQuery;
  $('.m-header-menu-opener .ToggleMenu').click(function(){
    $('body').addClass('has-open-menu')
    $('head meta[name="theme-color"]').attr('content','#000');
    return false;
  })
}